// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__30Qqd","header":"MergedInvoice_header__1H55B"};